import { useCallback } from 'react'

import { deleteDriverAssignments } from '@/features/domain/driverAssignments'
import { ConfirmPanel } from '@/forms-legacy'
import { useNotification, useIsUnmounted } from '@/hooks'
import { useAppDispatch } from '@/store'

import { useRecurrences } from '../hooks/useRecurrences'
import { useTexts } from '../hooks/useTexts'

interface Props {
  setView: (view: 'default' | 'delete') => void
}

export function DeletePanel(props: Props) {
  const { setView } = props
  const unmounted = useIsUnmounted()

  const texts = useTexts()
  const toast = useNotification()
  const dispatch = useAppDispatch()

  const recurrences = useRecurrences()

  const onCancel = useCallback(() => {
    setView('default')
  }, [setView])

  const onConfirm = useCallback(async () => {
    try {
      if (!recurrences) {
        throw new Error('recurrences not provided')
      }
      const sources = recurrences.map(r => r.source)
      const result = await dispatch(deleteDriverAssignments(sources))

      if (!deleteDriverAssignments.fulfilled.match(result)) {
        throw new Error(result.payload?.message ?? 'Internal error')
      }

      if (!unmounted()) {
        setView('default')
      }
    } catch (e) {
      toast.error(e.message)
    }
  }, [setView, dispatch, toast, recurrences, unmounted])

  const count = recurrences.length

  return (
    <ConfirmPanel
      title={texts.confirmPanelTitle(count)}
      description={texts.confirmPanelSubtitle}
      confirmationText={texts.delete}
      onCancel={onCancel}
      onConfirm={onConfirm}
      testid="setup-driverAssignments__bulk-delete-confirm-panel"
    />
  )
}
